import { ApiError } from "@wellcheck/api-client";

/**
 * isSubmitNotAllowedError — POST /api/respondent-answers の 409 が
 * 「提出不可 (未受検/不達/未案内、ADR-0054)」によるものかを判定する。
 *
 * isAnswerClosedError (./answerDeadline.ts) と対になる判定関数。backend
 * (handlers/answers.go submit) は answers.ErrSubmitNotAllowed を detail 文字列
 * "submission not allowed in current status" の 409 に写像する。この detail は
 * answers.ErrAlreadySubmitted ("answers already submitted") とは別文言のため区別できる。
 *
 * detail 文言はサーバ側の契約として明示されていない実装依存の値のため、ここでの判定が
 * backend の文言変更に対して脆いことは許容する (isAnswerClosedError と同種のリスク)。
 */
const SUBMIT_NOT_ALLOWED_DETAIL = "submission not allowed in current status";

export function isSubmitNotAllowedError(error: unknown): boolean {
  if (!(error instanceof ApiError) || error.status !== 409) {
    return false;
  }
  const data = error.data;
  if (typeof data !== "object" || data === null || !("detail" in data)) {
    return false;
  }
  return (data as { detail: unknown }).detail === SUBMIT_NOT_ALLOWED_DETAIL;
}
